import React, { useState } from 'react';
import {
  AvailableOrderFulfillmentFieldsFragment,
  NewOrder_OrderFieldsFragment,
} from '@/types';
import { EditFulfillmentDateButton } from '@/components/orders/edit-fulfillment-date-button';
import {
  FulfillmentActionSheetRoute,
  useFulfillmentPicker,
} from './use-fulfillment-picker';
import { FulfillmentPickerPopover } from './fulfillment-picker-popover';
import { SelectedFulfillmentType } from '@/contexts/new-order-actions-context-types';
import { StyleProp, ViewStyle } from 'react-native';
import { TrackingProperties } from '@/utils/analytics/base-reporter';

interface Props {
  draftOrder: NewOrder_OrderFieldsFragment | null;
  fulfillmentOptions: AvailableOrderFulfillmentFieldsFragment[];
  onSave: (selectedFulfillment: SelectedFulfillmentType) => Promise<void>;
  selectedFulfillment: SelectedFulfillmentType;
  style?: StyleProp<ViewStyle>;
  trackingProperties: TrackingProperties | null;
}

export const FulfillmentPickerDropdown: React.FC<Props> = ({
  draftOrder,
  fulfillmentOptions,
  onSave,
  selectedFulfillment,
  style,
  trackingProperties,
}) => {
  const [activeRoute, setActiveRoute] =
    useState<FulfillmentActionSheetRoute | null>(null);

  const handleClose = () => setActiveRoute(null);

  const picker = useFulfillmentPicker({
    draftOrder,
    fulfillmentOptions,
    initialSelectedFulfillment: selectedFulfillment,
    onClose: handleClose,
    onSave,
  });

  return (
    <FulfillmentPickerPopover
      activeRoute={activeRoute}
      draftOrder={draftOrder}
      jumpTo={setActiveRoute}
      onClose={handleClose}
      picker={picker}
      style={style}
      trackingProperties={trackingProperties}
      trigger={
        <EditFulfillmentDateButton
          date={selectedFulfillment.date}
          fulfillmentType={selectedFulfillment.type}
          onPress={() => {
            if (activeRoute !== null) {
              handleClose();
              return;
            }
            picker.resetSelection();
            setActiveRoute(picker.defaultInitialRoute);
          }}
          testID="order-summary-fulfillment-select"
          trackingData={{
            name: 'order_summary.fulfillment_button',
            properties: {
              orderUUID: draftOrder?.uuid,
              ...trackingProperties,
            },
          }}
        />
      }
    />
  );
};
